import { makeAutoObservable } from "mobx";
import { RootStore } from "stores";

export default class JobListViewStore {
  searchQuery = "";
  statusFilter = "all";

  private rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, { rootStore: false } as any);
  }

  setSearchQuery(query: string) {
    this.searchQuery = query;
  }

  setStatusFilter(status: string) {
    this.statusFilter = status;
  }

  get projects() {
    return (
      ((this.rootStore as any).manholeProjectsStore as any)?.entities || []
    );
  }

  get structures() {
    return (
      ((this.rootStore as any).manholeStructuresStore as any)?.entities || []
    );
  }

  get quotes() {
    return (
      ((this.rootStore as any).manholeQuotesStore as any)?.entities || []
    );
  }

  get filteredProjects() {
    let result = this.projects;

    // Status filter
    if (this.statusFilter !== "all") {
      result = result.filter((p: any) => p.status === this.statusFilter);
    }

    // Search filter
    if (this.searchQuery.trim()) {
      const query = this.searchQuery.toLowerCase();
      result = result.filter(
        (p: any) =>
          (p.jobName || "").toLowerCase().includes(query) ||
          (p.jobIdentifier || "").toLowerCase().includes(query) ||
          (p.customerName || "").toLowerCase().includes(query)
      );
    }

    return result;
  }

  get projectsWithStats() {
    return this.filteredProjects.map((project: any) => {
      const projectId = project.id || project.projectId;

      const structureCount = this.structures.filter(
        (s: any) => s.projectId === projectId
      ).length;

      const linkedQuote = this.quotes.find(
        (q: any) =>
          q.manholeProjectId === projectId ||
          q.projectId === projectId
      );

      return {
        ...project,
        structureCount,
        quoteTotal: linkedQuote?.total || 0,
      };
    });
  }

  reset() {
    this.searchQuery = "";
    this.statusFilter = "all";
  }
}
